export const FoldedLeafletDesignIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="4" />
        <path
            d="M20.2366 20.7338C17.0285 21.1871 16.0001 22.3239 16.0001 22.3239M16.0001 22.3239V11.4486C16.0001 11.4486 14.4597 9.74547 9.26628 9.67678C9.18014 9.6757 9.09725 9.7095 9.03664 9.77046C8.97543 9.83167 8.94114 9.91456 8.94126 10.0009V20.2279C8.93982 20.4028 9.07923 20.5469 9.25499 20.552C14.4584 20.6219 16.0001 22.3239 16.0001 22.3239Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16 11.4486C16 11.4486 17.5404 9.74547 22.7338 9.67678C22.8199 9.6757 22.9029 9.7095 22.9635 9.77046C23.0246 9.83167 23.059 9.91456 23.0588 10.0009V17.6398"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.2353 20.7239V17.9821C20.2381 17.7904 20.3961 17.6371 20.5885 17.6392H23.0588L20.2353 20.7239Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
